import type { FC } from 'react'

import clsx from 'clsx'

import { RestPlaceCardItem } from 'entities/kyrgyzstan'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Skeleton, SkeletonTheme } from 'shared/ui/skeleton'

import s from './styles.module.scss'

const SkeletonItemsCount = 6
interface RestPlacesGridLayoutProps {
  places: RestPlaceCardItem[]
  isLoading?: boolean
  onSelectPlace?: (place: RestPlaceCardItem) => void
}

const RestPlacesGridSkeleton = () => (
  <SkeletonTheme
    baseColor="var(--grey-32)"
    highlightColor="var(--grey-33)"
  >
    <div className={s.container}>
      {Array.from({ length: SkeletonItemsCount }).map((_, index) => (
        <div
          key={index}
          className={s.skeletonItem}
        >
          <Skeleton className={s.skeletonItemImage} />
        </div>
      ))}
    </div>
  </SkeletonTheme>
)

export const RestPlacesGridLayout: FC<RestPlacesGridLayoutProps> = ({
  places,
  isLoading = false,
  onSelectPlace,
}) => {
  if (isLoading) {
    return <RestPlacesGridSkeleton />
  }

  return (
    <div className={s.container}>
      {places.map((place, index) => (
        <button
          key={place.id ?? index}
          type="button"
          className={s.card}
          onClick={() => onSelectPlace?.(place)}
          aria-label={place.title}
        >
          {place.image ? (
            <img
              src={place.image}
              alt={place.title}
              className={s.image}
              loading="lazy"
            />
          ) : (
            <div className={s.placeholder}>
              <AppIcon
                id={AllIcons.PIN}
                width={24}
                height={24}
              />
            </div>
          )}

          <p className={clsx('bold-16', s.title)}>{place.title}</p>
        </button>
      ))}
    </div>
  )
}
